// src/pages/Perfil.jsx

import React, { useState, useEffect } from 'react';

import {

  Typography,

  Box,

  Button,

  TextField,

  MenuItem,

  Grid,

  Alert,

  CircularProgress,

  Paper,

  Container,

  Dialog,

  DialogContent,

  DialogTitle,

  DialogActions

} from '@mui/material';

import { useAuth } from '../../contexts/AuthContext';

import api from '../../services/api';

import ChangePasswordModal from '../../components/ChangePasswordModal';

import { useTranslation } from 'react-i18next';

import MenuBookIcon from '@mui/icons-material/MenuBook';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import PlataformaSelector from '../../components/guias/PlataformaSelector';
import ActiveCampaignForm from '../../components/ActiveCampaignForm';



const Perfil = () => {

  const { user } = useAuth();

  const { t } = useTranslation();



  const [formData, setFormData] = useState({

    email: '',

    tipoCuenta: '', // 'Consumer' o 'Business'

    customer_name: '',

    date_of_birth: '',

    numeroTelefono: '',

    billing_cycle: '01', // Añadir con valor predeterminado

    billing_address: {

      postal_code: '',

      region: '',

      city: '',

      address: '',

      country_code: '',

    },

    fiscal_identification: '',

  });

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [success, setSuccess] = useState('');

  const [isEditing, setIsEditing] = useState(false);



  // Estado para controlar el modal

  const [openChangePassword, setOpenChangePassword] = useState(false);



  // Nuevos estados para el header

  const [guidesModalOpen, setGuidesModalOpen] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);



  // Funciones para el header

  const handleOpenGuidesModal = () => {

    setGuidesModalOpen(true);

  };



  const handleCloseGuidesModal = () => {

    setGuidesModalOpen(false);

  };



  const handleAddNewDomain = () => {

    setModalOpen(true);

  };



  const handleCloseModal = () => {

    setModalOpen(false);

  };



  useEffect(() => {

    const fetchCustomerDetails = async () => {

      try {

        const response = await api.get(`/customer-details?user_id=${user.id}`);

        setFormData({

          email: response.data.email || '',

          tipoCuenta: response.data.tipoCuenta || '',

          customer_name: response.data.nombre || '',

          date_of_birth: response.data.fechaNacimiento || '',

          numeroTelefono: response.data.telefono || '',

          billing_cycle: response.data.billing_cycle || '01', // Cargar el valor o default a 01

          billing_address: {

            postal_code: response.data.billing_address.postal_code || '',

            region: response.data.billing_address.region || '',

            city: response.data.billing_address.city || '',

            address: response.data.billing_address.address || '',

            country_code: response.data.billing_address.country_code || '',

          },

          fiscal_identification: response.data.fiscal_identification || '',

        });

      } catch (err) {

        setError(t('profile.errorFetchingDetails'));

      } finally {

        setLoading(false);

      }

    };



    if (user && user.id) {

      fetchCustomerDetails();

    }

  }, [user, t]);



  const handleChange = (e) => {

    const { name, value } = e.target;



    if (name.startsWith('billing_address.')) {

      const field = name.split('.')[1];

      setFormData((prev) => ({

        ...prev,

        billing_address: {

          ...prev.billing_address,

          [field]: value,

        },

      }));

    } else {

      setFormData((prev) => ({

        ...prev,

        [name]: value,

      }));

    }

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    setError('');

    setSuccess('');



    try {

      const response = await api.put('/update-customer-details', {

        user_id: user.id,

        billing_cycle: '01', // Mantener el valor fijo

        billing_address: formData.billing_address,

        fiscal_identification: formData.fiscal_identification,

        customer_name: formData.customer_name,

        numeroTelefono: formData.numeroTelefono,

        date_of_birth: formData.date_of_birth,

      });



      if (response.data.success) {

        setSuccess(t('profile.updateSuccess'));

        setIsEditing(false);

      }

    } catch (err) {

      setError(err.response?.data?.error || t('profile.updateError'));

    }

  };



  const toggleEdit = () => {

    setIsEditing((prev) => !prev);

    setError('');

    setSuccess('');

  };



  // Funciones para manejar el modal

  const handleOpenChangePassword = () => {

    setOpenChangePassword(true);

  };



  const handleCloseChangePassword = () => {

    setOpenChangePassword(false);

  };



  if (loading) {

    return (

      <Box sx={{ mt: 10, textAlign: 'center' }}>

        <CircularProgress />

        <Typography sx={{ mt: 2 }}>{t('profile.loading')}</Typography>

      </Box>

    );

  }



  return (

    <Box

      sx={{

        display: "flex",

        flexDirection: "column",

        width: "100%",

        maxWidth: "100vw",

        px: { xs: 0, md: 2.5 },

        py: { xs: 0, md: 4 },

        pb: 0,

        mr: { xs: -6 },

        pr: { xs: 0 },

      }}

    >

      {/* Cabecera fija */}

      <Box

        sx={{

          display: "flex",

          flexDirection: "column",

          width: "100%",

          position: "fixed",

          top: 0,

          left: 0,

          right: 0,

          padding: { xs: "12px 16px", sm: "8px 16px", md: "12px 16px" },

          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",

          backgroundColor: "white",

          zIndex: 1000,

        }}

      >

        {/* Fila principal */}

        <Box

          sx={{

            display: "flex",

            justifyContent: "space-between",

            alignItems: "center",

            width: "100%",

          }}

        >

          {/* Columna izquierda: Texto */}

          <Box sx={{ 

            display: { xs: "flex", sm: "flex" }, 

            flexDirection: "column", 

            flex: 1,

            ml: { xs: "50px", sm: "50px", md: 35.5 },

          }}>

            <Typography

              variant="h5"

              sx={{

                fontSize: { xs: "18px", sm: "16px", md: "14px", lg: "20px" },

                fontWeight: "medium",

                color: "#000",

              }}

            >

              {t('Configuración de la cuenta')}

            </Typography>



            <Typography

              variant="subtitle1"

              sx={{

                fontSize: { xs: "12px", sm: "15px", md: "14px" },

                color: "#666",

                mt: { xs: 0, md: 0.3 },

                display: { xs: "none", sm: "none", md: "none", lg: "block" },

              }}

            >

              {t('Desde este panel puedes configurar los aspectos relacionados con tu cuenta.')}

            </Typography>

          </Box>



          {/* Columna derecha: Botones */}

          <Box

            sx={{

              display: "flex",

              gap: { xs: 1.5, sm: 2 },

              mr: { xs: 1.5, md: 5 },

              alignItems: "center",

            }}

          >

            <Box sx={{ display: { xs: "none", sm: "none", md: "none", lg: "flex" }, gap: 0.5 }}>

              <Button

                variant="outlined"

                onClick={handleOpenGuidesModal}

                startIcon={<MenuBookIcon />}

                sx={{

                  textTransform: "none",

                  fontWeight: "medium",

                  color: "#0F52BD",

                  borderColor: "#0F52BD",

                  fontSize: { sm: "12px", md: "12px" },

                  px: { sm: 1.5, md: 1.5 },

                  py: { sm: 0.8, md: 0.8 },

                  borderWidth: "2px",

                  borderRadius: "8px",

                }}

              >

                {t("home.implementationGuide")}

              </Button>

            </Box>

            

            <Box sx={{ display: { xs: "none", sm: "block" } }}>

              <Button

                variant="contained"

                startIcon={<AddCircleOutlineIcon sx={{ fontSize: { sm: "18px", md: "16px" } }} />}

                onClick={handleAddNewDomain}

                sx={{

                  textTransform: "none",

                  fontWeight: "medium",

                  backgroundColor: "#0F52BD",

                  fontSize: { sm: "12px", md: "12px" },

                  px: { sm: 1.5, md: 1.5 },

                  py: { sm: 0.8, md: 0.8 },

                  borderRadius: "8px",

                }}

              >

                {t("home.addNewDomain")}

              </Button>

            </Box>

          </Box>

        </Box>

      </Box>



      {/* Spacer para empujar el contenido hacia abajo */}

      <Box

        sx={{

          height: { xs: "65px", sm: "70px", md: "100px", lg: "90px" },

          "@media (max-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "65px",

          },

          "@media (max-width: 600px) and (min-resolution: 1.5dppx)": {

            height: "90px",

          },

          "@media (min-width: 600px) and (min-resolution: 1.25dppx)": {

            height: "75px",

          },

          "@media (min-width: 900px) and (min-resolution: 1.25dppx)": {

            height: "95px",

          },

        }}

      />



      {/* Contenido principal */}

      <Box sx={{ ml: { xs: -6, md: 0 } }}>

        <Box

          sx={{ paddingLeft: { xs: 6, md: 2 }, paddingRight: { xs: 0, md: 4 } }}

        >

      <Container sx={{ 

        mt: { xs: 0, md: 2 }, 

        mb: -7, 

        transform: {xs: 'scale(0.9)', md: 'scale(1)'}, 

        p: 0,

      }}>



        {/* Alertas */}

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}



        <Grid container spacing={4} sx={{ transform: {xs: 'scale(1.1)', md: 'scale(1)'} }}>

          {/* Bloque Izquierdo */}

          <Grid item xs={12} md={6}>

            <Paper

              elevation={3}

              sx={{

                padding: 3,

                borderRadius: '10px',

                height: '100%',

                boxShadow: '0px 2px 25px 0px rgba(98, 113, 137, 0.46)',

              }}

            >

              {/* Información de cuenta */}

              <Box sx={{ mb: 4 }}>

                <Typography variant="h6" gutterBottom mb={3} color="#000">

                {t('profile.accountInfo')}

                </Typography>

                <Grid container spacing={2}>

                  <Grid item xs={12}>

                    <TextField

                      label={t('profile.email')}

                      name="email"

                      value={formData.email}

                      onChange={handleChange}

                      fullWidth

                      disabled={true}

                    />

                  </Grid>

                  <Grid item xs={12}>

                    <TextField

                      select

                      label={t('profile.accountType')}

                      name="tipoCuenta"

                      value={formData.tipoCuenta}

                      onChange={handleChange}

                      fullWidth

                      disabled={true}

                    >

                      <MenuItem value="Consumer">{t('profile.personal')}</MenuItem>

                      <MenuItem value="Business">{t('profile.business')}</MenuItem>

                    </TextField>

                  </Grid>

                </Grid>

              </Box>



              {/* Información general */}

              <Box>

                <Typography variant="h6" gutterBottom mb={3} color="#000">

                {t('profile.generalInfo')}

                </Typography>

                <Grid container spacing={2}>

                  <Grid item xs={12}>

                    <TextField

                      label={t('profile.country')}

                      name="billing_address.country_code"

                      value={formData.billing_address.country_code}

                      onChange={handleChange}

                      fullWidth

                      disabled={true}

                    />

                  </Grid>

                  <Grid item xs={12}>

                    <TextField

                      label={formData.accountType === 'Business' ? t('profile.nif') : t('profile.dni')}

                      name="fiscal_identification"

                      value={formData.fiscal_identification}

                      onChange={handleChange}

                      fullWidth

                      disabled={!isEditing}

                      required

                    />

                  </Grid>

                  <Grid item xs={12}>

                    <TextField

                      label={t('profile.fullName')}

                      name="customer_name"

                      value={formData.customer_name}

                      onChange={handleChange}

                      fullWidth

                      disabled={!isEditing}

                      required

                    />

                  </Grid>

                  <Grid item xs={12}>

                    <TextField

                      label={t('profile.phoneNumber')}

                      name="numeroTelefono"

                      value={formData.numeroTelefono}

                      onChange={handleChange}

                      fullWidth

                      disabled={!isEditing}

                      required

                    />

                  </Grid>

                  {formData.tipoCuenta === 'Consumer' && (

                    <Grid item xs={12}>

                      <TextField

                        label={t('profile.dateOfBirth')}

                        type="date"

                        name="date_of_birth"

                        value={formData.date_of_birth}

                        onChange={handleChange}

                        fullWidth

                        disabled={!isEditing}

                        InputLabelProps={{

                          shrink: true,

                        }}

                      />

                    </Grid>

                  )}

                </Grid>

              </Box>

            </Paper>

          </Grid>



          {/* Bloque Derecho */}

          <Grid item xs={12} md={6}>

            <Grid container spacing={4} direction="column">

              {/* Datos de facturación */}

              <Grid item>

                <Paper

                  elevation={3}

                  sx={{

                    padding: 3,

                    boxShadow: '0px 2px 25px 0px rgba(98, 113, 137, 0.46)',

                    borderRadius: '10px',

                    height: '100%',

                  }}

                >

                  <Typography variant="h6" gutterBottom mb={3} color="#000">

                  {t('profile.billingInfo')}

                  </Typography>

                  <Grid container spacing={2}>

                    <Grid item xs={12}>

                      <TextField

                        label={t('profile.postalCode')}

                        name="billing_address.postal_code"

                        value={formData.billing_address.postal_code}

                        onChange={handleChange}

                        fullWidth

                        disabled={!isEditing}

                        required

                      />

                    </Grid>

                    <Grid item xs={12}>

                      <TextField

                        label={t('profile.region')}

                        name="billing_address.region"

                        value={formData.billing_address.region}

                        onChange={handleChange}

                        fullWidth

                        disabled={!isEditing}

                        required

                      />

                    </Grid>

                    <Grid item xs={12}>

                      <TextField

                        label={t('profile.city')}

                        name="billing_address.city"

                        value={formData.billing_address.city}

                        onChange={handleChange}

                        fullWidth

                        disabled={!isEditing}

                        required

                      />

                    </Grid>

                    <Grid item xs={12}>

                      <TextField

                        label={t('profile.address')}

                        name="billing_address.address"

                        value={formData.billing_address.address}

                        onChange={handleChange}

                        fullWidth

                        disabled={!isEditing}

                        required

                      />

                    </Grid>

                  </Grid>

                </Paper>

              </Grid>



              {/* Seguridad y cuenta */}

              <Grid item>

                <Paper

                  elevation={3}

                  sx={{

                    padding: 3,

                    borderRadius: '10px',

                    height: '100%',

                    boxShadow: '0px 2px 25px 0px rgba(98, 113, 137, 0.46)',

                  }}

                >

                  <Typography variant="h6" gutterBottom color="#000">

                  {t('profile.securityAccount')}

                  </Typography>

                  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>

                    <Button

                      variant="contained"

                      onClick={handleOpenChangePassword}

                      sx={{ textTransform: 'none', backgroundColor: '#0F52BD', paddingX: 4, paddingY: 1 }}

                    >

                      {t('profile.changePassword')}

                    </Button>

                  </Box>

                </Paper>

              </Grid>

            </Grid>

          </Grid>

        </Grid>



        {/* Botón de Edición */}

        <Box sx={{ display: 'flex', justifyContent: 'left', mt: {xs: 13, md: 4}, overflow: 'hidden', transform: {xs: 'scale(1.1)', md: 'scale(1)'}, mb: {xs: -3, md: 0} }}>

          {!isEditing ? (

            <Button

              variant="contained"

              color="primary"

              onClick={toggleEdit}

              sx={{

                textTransform: 'none',

                paddingX: 3,

                paddingY: 1,

                transition: 'all 0.3s ease',

              }}

            >

              {t('profile.editProfile')}

            </Button>

          ) : (

            <>

              <Button

                color="primary"

                onClick={toggleEdit}

                sx={{

                  textTransform: 'none',

                  opacity: 0,

                  transform: 'translateX(100%)',

                  animation: 'slideIn 0.3s forwards',

                  transition: 'all 0.3s ease',

                  '@keyframes slideIn': {

                    from: { opacity: 0, transform: 'translateX(100%)' },

                    to: { opacity: 1, transform: 'translateX(0)' },

                  },

                }}

              >

                 {t('profile.cancel')}

              </Button>



              <Button

                variant="contained"

                color="primary"

                onClick={handleSubmit}

                sx={{

                  textTransform: 'none',

                  paddingX: 3,

                  paddingY: 1,

                  ml: 2,

                  transition: 'all 0.3s ease',

                }}

              >

                {t('profile.saveChanges')}

              </Button>

            </>

          )}

        </Box>



        {/* Modal de Cambio de Contraseña */}

        <ChangePasswordModal open={openChangePassword} handleClose={handleCloseChangePassword} />

      </Container>



      {/* Modal de guías */}

      <Dialog 

        open={guidesModalOpen} 

        onClose={handleCloseGuidesModal} 

        fullWidth 

        maxWidth="lg"

        PaperProps={{

          sx: {

            borderRadius: 3,

            p: 0,

            m: 0,

            overflow: 'hidden',

            '& .MuiDialogContent-root': {

              padding: 0,

              margin: 0,

            }

          }

        }}

      >

        <DialogContent sx={{ 

          padding: 0, 

          margin: 0,

          '&:first-of-type': {

            paddingTop: 0

          }

        }}>

          <PlataformaSelector onClose={handleCloseGuidesModal} />

        </DialogContent>

      </Dialog>



      {/* Modal para añadir nuevo dominio */}

      <Dialog open={modalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">

        <DialogTitle sx={{ fontWeight: 'medium', fontSize: '24px' }}>{t("Suscribirse a un Widget")}</DialogTitle>

        <DialogContent sx={{ padding: '25px' }}>

          <ActiveCampaignForm open={modalOpen} />

        </DialogContent>

        <DialogActions sx={{ paddingRight: '25px', paddingBottom: '25px' }}>

          <Button onClick={handleCloseModal} sx={{ textTransform: 'none', fontSize: '16px', fontWeight: 'regular' }}>

            {t("Cerrar")}

          </Button>

        </DialogActions>

      </Dialog>

        </Box>

      </Box>

    </Box>

  );

};



export default Perfil;
